import { IStyleInfo } from '../interface/custom-types'

export function getTypes<T>(formats: IStyleInfo<T>[]) {
  return formats.map((item) => item.style)
}
